import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EquipYourVision from "./sections/EquipYourVision";
import ExploreByEquipmentType from "./sections/ExploreByEquipmentType";
import FeaturedMiningEquipment from "./sections/FeaturedMiningEquipment";
import PoweringProgress from "./sections/PoweringProgress";
import BrowseOurConstructionCollection from "./sections/BrowseOurConstructionCollection";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EquipYourVision />
      <ExploreByEquipmentType />
      <FeaturedMiningEquipment />
      <PoweringProgress />
      <BrowseOurConstructionCollection />
      <Footer />
    </div>;
}